// experience-backend has no cause-type-translations endpoint yet; honest no-op.
const getCauseTypesByIdsWithTranslations = async (ids) => {
  console.warn(
    "getCauseTypesByIds: getCauseTypesByIdsWithTranslations is not supported by experience-backend yet.",
    { ids }
  );
  return [];
};

export default async function getCauseTypesByIds(ids) {
  try {
    if (!ids || ids.length === 0) throw new Error("No IDs provided");
    const enriched = await getCauseTypesByIdsWithTranslations(ids);
    console.log(
      `[getCauseTypesByIds] translations fetched for ${enriched.length} cause types`
    );
    return enriched;
  } catch (error) {
    console.error(
      "[getCauseTypesByIds] Error fetching causeTypes with translations:",
      error
    );
    return [];
  }
}
